import React from 'react';

export const dealingWithOtherUsersMessages = {
  value: 'Dealing with Other Users',
  list: [
    {
      value: (
        <>
          Notwithstanding Glints uses its best endeavors to provide impartial
          job seeking and recruitment services, and represents a media
          supporting information exchanged between Advertisers and Job Seekers,
          Glints will not be involved in dealings or disputes between Job Seeker
          and Advertiser and Glints shall not be responsible or held liable for
          the quality, security and legitimacy of the recruitment service.
          Glints does not warrant or guarantee the accuracy of the information
          and/or the resume provided by Job Seeker or of the recruitment
          advertisements provided by Advertiser. Glints does not guarantee that
          Advertiser will be able to pay the relevant remuneration or that Job
          Seeker will be competent to take the job offered by the Advertiser.
          Should any dispute arise between Advertiser and Job Seeker, Advertiser
          and Job Seeker shall resolve such disputes between themselves and
          Glints shall not be responsible and held liable for any disputes
          thereof.
        </>
      ),
    },
  ],
};
